import {Component} from '@angular/core';
import { NavController, NavParams ,ViewController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Events} from 'ionic-angular';
import { SpinnerDialog } from 'ionic-native';
import {LoginPage} from '../login/login';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'webstore-user-add-popup',
  templateUrl: 'webstore-user-add-popup.html'
})
export class WebstoreUserAddPopup{

  customer : any;
  user:any;
  callStatus = 0;
  tempCust:any;
  formStatus = false;
  buttonText = "";
  firstName = "";
  lastName = "";
  phone = "";
  pageTitle = "";
  emailReadOnly= false;
  userNameReadOnly= false;


  userUnique = true; // true for update only

	constructor(private nav:NavController,
    private api:Api,
    private params: NavParams,
    private cartManager:CartManager,
    private msgManager:MsgManager,
    private viewController:ViewController,
    private toastController:ToastController,
    private events:Events,
    private gVLogger: GVLogger){
		this.customer = this.params.get("customer");

    this.buttonText = this.params.get("button");

    this.tempCust = this.customer;
    if(!this.customer.userName){
      this.customer.userName ="";
    }
    if(!this.customer.password){
      this.customer.password = "";
    }
    if(this.customer.userFirstName){
      this.firstName = this.customer.userFirstName;
    }
    if(this.customer.userLastName){
      this.lastName = this.customer.userLastName;
    }
    if(this.customer.phone){
      this.phone = this.customer.phone;
    }

    if(this.buttonText == "CREATE"){
      this.pageTitle = "Create User - ";
      this.userUnique = false;
    }else{
      this.pageTitle = "Update User - ";
      this.userNameReadOnly = true;
      this.emailReadOnly = true;
    }
	}


  serverCall(){
    if(this.buttonText == "CREATE"){
      this.createCall();
    }else{
      this.updateCall();
    }
  }

  createCall(){

    this.validateForm();
    if(this.formStatus){
       this.gVLogger.log("Create Call...");
       SpinnerDialog.show(this.msgManager.getLoadingMsg());
       this.api.post("customers/createUserByCustomer",this.genrateBody()).map(res => res.json()).subscribe(result =>{
         if(result.status == "200"){
           this.callStatus = 1;
           this.viewController.dismiss(this.returnData(true));
           this.toastMsg(result.message);
           this.events.publish("webstoreUserUpdated");
         }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }else{
           this.customer = this.tempCust;
           this.viewController.dismiss(this.returnData(false));
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.customer = this.tempCust;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData(false));
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  updateCall(){
    this.validateForm();
    if(this.formStatus){
      this.gVLogger.log("Update Call...");
      SpinnerDialog.show(this.msgManager.getLoadingMsg());
       this.api.post("customers/editUserByCustomer",this.genrateBody()).map(res => res.json()).subscribe(result =>{
         if(result.status == "200"){
           this.callStatus = 1;
           this.toastMsg(result.message);
           this.events.publish("webstoreUserUpdated");
           this.viewController.dismiss(this.returnData(true));
         }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }else{
           this.customer = this.tempCust;
           this.viewController.dismiss(this.returnData(false));
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.customer = this.tempCust;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData(false));
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  genrateBody(){
    if (this.customer.userStatus == "1" || this.customer.userStatus == true) {
      this.customer.userStatus = "1"
    }else{
      this.customer.userStatus = "0"
    }

    return {
        customerId: this.customer.id,
        changeBy: this.cartManager.getSalesPerson().id,
        userFirstName: this.firstName ,
        userLastName: this.lastName,
        userName: this.customer.userName,
        userEmail: this.customer.email,
        password: this.customer.password,
        userStatus: this.customer.userStatus,
        userPhone: this.phone,
        userRole: 2
    }
  }

  validateForm(){
    if( this.customer.userName == "" ||
    this.customer.password == "" ||
    this.firstName == "" ||
    this.lastName == "" ||
    this.customer.email == "" ||
    this.phone == ""){
      this.formStatus = false;
    }else{
      if(this.userUnique){
        this.formStatus = true;
       }else{
         let toast = this.toastController.create({
              message: "User name not available please choose other.",
              duration: 3000
            });
            toast.present();
       }
    }
  }

  cancelPopup(){
    this.viewController.dismiss(this.returnData(false));
  }

  toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }

  returnData(goBack){
    if (this.customer.userStatus == "1") {
      this.customer.userStatus = 1
    }else{
      this.customer.userStatus = 0
    }
    return {
      customer: this.customer,
      callStatus: this.callStatus,
      goBack: goBack
    }
  }


   checkUsernameUniqeness(){

    this.gVLogger.log(this.customer.userName +" -- - - ");
   // var body:any = { "query":};

    // let body = new FormData();
    // body.append('query', this.customer.userName );

    let body ={
      query:this.customer.userName
    };

    this.api.get('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status=="200"){
            this.userUnique = true;

          }else if(resp.status=="500"){
            this.userUnique = false;
            let toast = this.toastController.create({
              message: "User name not available please choose other.",
              duration: 3000
            });
            toast.present();
          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }
        });
  }

}



// WEBPACK FOOTER //
// ./src/pages/webstore-user-add-popup/webstore-user-add-popup.ts